export const categories = [
  {
    key: "1980s",
    name: "80年代",
    group: "按年代",
    icon: "ri-history-line",
    description: "香港电影新浪潮余波下的探索期，类型片逐步成形，创作者开始尝试更大胆的题材表达。",
    criteria: { decade: "1980s" },
  },
  {
    key: "1990s",
    name: "90年代",
    group: "按年代",
    icon: "ri-time-line",
    description: "该类型片的黄金年代，产量、话题度与市场影响力均达到高峰，众多代表作集中诞生于此。",
    criteria: { decade: "1990s" },
  },
  {
    key: "2000s",
    name: "2000年后",
    group: "按年代",
    icon: "ri-calendar-line",
    description: "随着市场与审查环境变化，创作转向更精致的制作与更明确的类型定位。",
    criteria: { decade: "2000s" },
  },
  {
    key: "genre-drama",
    name: "剧情",
    group: "按类型",
    icon: "ri-film-line",
    description: "以人物与情感为核心，注重叙事深度与社会观察的作品。",
    criteria: { genre: "剧情" },
  },
  {
    key: "genre-crime",
    name: "犯罪惊悚",
    group: "按类型",
    icon: "ri-alarm-warning-line",
    description: "取材奇案与警匪题材，以纪实或悬疑手法营造紧张感。",
    criteria: { genre: "犯罪" },
  },
  {
    key: "genre-ancient",
    name: "古装",
    group: "按类型",
    icon: "ri-ancient-gate-line",
    description: "以古代社会为背景，融合民间传奇与华丽布景的类型作品。",
    criteria: { genre: "古装" },
  },
  {
    key: "genre-comedy",
    name: "喜剧",
    group: "按类型",
    icon: "ri-emotion-laugh-line",
    description: "夸张诙谐，以市井趣味与无厘头桥段娱乐观众。",
    criteria: { genre: "喜剧" },
  },
  {
    key: "genre-romance",
    name: "爱情",
    group: "按类型",
    icon: "ri-heart-line",
    description: "聚焦都市男女的情感关系，描摹时代变迁中的情感焦虑。",
    criteria: { genre: "爱情" },
  },
  {
    key: "top-rated",
    name: "高分佳作",
    group: "按评分",
    icon: "ri-star-line",
    description: "综合口碑与艺术评价，评分靠前的代表性作品合集。",
    criteria: { minRating: 6.0 },
  },
  {
    key: "director-ershi",
    name: "尔冬升",
    group: "按导演",
    icon: "ri-user-star-line",
    description: "以行业题材与写实风格见长的导演，作品兼具娱乐性与思考性。",
    criteria: { director: "尔冬升" },
  },
  {
    key: "director-mak",
    name: "麦当雄",
    group: "按导演",
    icon: "ri-user-star-line",
    description: "擅长古装与话题题材的制作人，作品往往引领市场风潮。",
    criteria: { director: "麦当雄" },
  },
  {
    key: "director-lee",
    name: "李修贤",
    group: "按导演",
    icon: "ri-user-star-line",
    description: "以警匪与犯罪题材著称的导演，影像风格写实克制。",
    criteria: { director: "李修贤" },
  },
];

export const homepageFeaturedCategories = [
  "1990s",
  "genre-drama",
  "genre-crime",
  "genre-ancient",
  "top-rated",
  "director-ershi",
];